module.exports = __webpack_public_path__ + "ff61c31c847e1cb9e9e2ab080894fd11.woff";